import { Card, Col } from 'reactstrap'
import { raiseInputStyleSubTitle } from '../../../../../Data/Forms/FormsControl/BaseInput/BaseInput'
import { RaiseInputStyles } from '../../../../../Utils/Constants'
import RaiseInputStyleForm from './RaiseInputStyleForm'
import CardHeaderCommon from '../../../../../Utils/CommonComponents/CardHeaderCommon'

const RaiseInputStyle = () => {
  return (
    <Col md="6">
      <Card>
        <CardHeaderCommon title={RaiseInputStyles} span={raiseInputStyleSubTitle} />
        <RaiseInputStyleForm />
      </Card>
    </Col>
  )
}

export default RaiseInputStyle